import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { createRelayClient } from "./relay-client.js";
const RelayReactContext = createContext(null);
/**
 * RelayProvider either reuses an injected RelayClient or creates its own,
 * then connects/disconnects it whenever the active workspace changes.
 * Children consume the singleton via `useRelay()`.
 */
export function RelayProvider({ workspaceId, children, client, baseUrl, getToken, clientType, reconnectDelayMs, }) {
    const [fallback] = useState(() => {
        if (client)
            return null;
        if (!baseUrl || !getToken) {
            throw new Error("RelayProvider needs either `client` or both `baseUrl` and `getToken`.");
        }
        return createRelayClient({ baseUrl, getToken, clientType, reconnectDelayMs });
    });
    const active = client ?? fallback;
    if (!active)
        throw new Error("RelayProvider has no client");
    useEffect(() => {
        if (!workspaceId) {
            active.disconnect();
            return;
        }
        active.connect(workspaceId);
        return () => {
            active.disconnect();
        };
    }, [active, workspaceId]);
    const value = useMemo(() => active, [active]);
    return _jsx(RelayReactContext.Provider, { value: value, children: children });
}
export function useRelay() {
    const ctx = useContext(RelayReactContext);
    if (!ctx) {
        throw new Error("useRelay must be called inside <RelayProvider>.");
    }
    return ctx;
}
//# sourceMappingURL=relay-provider.js.map